@use '@fukuri-admins/ui/layout' as *;

// キーフレームアニメーション定義
@keyframes fadeIn {
  from {
    transform: translateY(-100%);
    opacity: 0;
    margin-top: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
    max-height: 44px;
    margin-top: 16px;
  }
}

@keyframes fadeOut {
  from {
    transform: translateY(0px);
    opacity: 1;
    max-height: 44px;
    margin-top: 16px;
  }

  to {
    max-height: 0;
    opacity: 0;
    margin-top: 0;
  }
}

// アニメーションラッパーのスタイル
.animationWrapper {
  animation: fadeIn 0.3s ease forwards;

  // クロージング状態のスタイル
  &.isClosing {
    animation: fadeOut 0.3s ease forwards;
  }
}
